/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import SearchIcon from "@material-ui/icons/Search";
import React from "react";
import { Link } from "react-router-dom";

export const HeaderSearch: React.FC = () => {
  return (
    <div>
      <Link id="search" to="/search" css={searchNavStyles} aria-label="Search">
        <SearchIcon aria-hidden="true" />
      </Link>
    </div>
  );
};

const searchNavStyles = css`
  cursor: pointer;
  color: white;
`;
